import React, {Component} from 'react';
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css'

class FormyTooltip extends Component {
  render() {
    return (
      <Tooltip html={(
        <div className="fs14 tal">
          {this.props.text}
        </div>
      )}
       animateFill={false}
       position="top"
       theme="dark"
      >
        {this.props.children}
      </Tooltip>
    )
  }
}


export default FormyTooltip;